import styled from 'styled-components';
import { theme } from 'styles';
import { BlueButton, Flex } from 'UI';

export const OperationItem = styled(Flex)<{ isActive: boolean }>`
  flex: 0 0 auto;
  height: 75px;
  position: relative;
  cursor: pointer;
  background-color: ${({ isActive }) => isActive && theme.color.grey95};

  &::after {
    content: '';
    position: absolute;
    left: 15%;
    right: 15%;
    bottom: 0;
    height: 1px;
    background-color: ${theme.color.grey90};
  }

  :hover {
    background-color: ${theme.color.grey95};
  }
`;

export const LoadingWrapper = styled(Flex)`
  box-shadow: -5px -2px 4px ${theme.color.grey95_light_130};
`;

export const StickyStrip = styled(Flex)`
  flex: 0 0 auto;
  height: 125px;
  position: fixed;
  left: var(--page-side-bar-width, 0px);
  right: 0;
  bottom: 0;
  padding: 0 30px;
  transition: left 200ms ease, right 200ms ease;
  will-change: left, right;
  box-shadow: 0 -4px 8px ${theme.color.grey85};
  background-color: ${theme.color.white};
  z-index: 889;
`;

export const ReferenceCardWrapper = styled(Flex)`
  border-radius: 15px;
  box-shadow: 0 3px 10px 0 ${theme.color.grey85};
`;

export const IconWrapper = styled(Flex)`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: ${theme.color.grey95};
  justify-content: center;
  align-items: center;
`;

export const SelectedQuantity = styled(Flex)`
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background-color: ${theme.color.info};
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SBlueButton = styled(BlueButton)`
  position: absolute;
  right: 15px;
`;
